// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const meloetta_pirouette: PokeData = {
  "id": 10018,
  "name": "meloetta-pirouette",
  "height": 6,
  "weight": 65,
  "base_experience": 270,
  "types": [
    PokeType.NORMAL,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "sing",
    "psybeam",
    "confusion",
    "psychic",
    "quick-attack",
    "perish-song",
    "role-play",
    "teeter-dance",
    "hyper-voice",
    "wake-up-slap",
    "u-turn",
    "close-combat",
    "round",
    "echoed-voice",
    "acrobatics",
    "relic-song"
  ],
  "moves": [
    "psychic",
    "quick-attack",
    "hyper-voice",
    "close-combat",
    "acrobatics",
    "karate-chop",
    "headbutt",
    "rolling-kick",
    "vacuum-wave",
    "leer",
    "scary-face",
    "splash",
    "scratch"
  ],
  "evolution_chain": {
    "id": 335,
    "item": null,
    "species": [
      {
        "name": "meloetta",
        "order": 649,
        "types": [
          PokeType.NORMAL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 106,
    "speed": 147,
    "ability_power": 147
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
